/* global gettext */

export const HSPLITTER = 650; // position of splitter without aggregate
export const WSPLITTER = $(window).height() / 2; // position of splitter without aggregate

export const DEFAULT_MODE = 'explore';
export const DEFAULT_DRILL = 'agent_time@ymdh:hour';
export const DEFAULT_FILTERS = []; //
export const DEFAULT_STAT_LIMIT = 5000;
export const DEFAULT_FEEDBACK_URL = '';

export const DEFAULT_MEASURES = {
  'call_duration_sum': gettext('Время разговора'),
  'activity_time_sum': gettext('Время активности'),
  'record_count'     : gettext('Количество событий'),
};

export const USE_CACHE = true;
export const HARD_LIMIT = 100;
export const DEFAULT_FILTER_LIMIT = 50;

export const PATH_STRING_SEPARATOR = 'ʻ'; // inverted comma



// WEBPACK FOOTER //
// ./src/common/config.js